import React from 'react';
import { Badge } from './Badge';
import { ClayUserIcon, ClayUserWithTextIcon } from '@repo/icons';
import Contact from '@repo/utils/models/Contact';

export function ClayUserBadge({
  contact,
  icon = false,
  image = false,
  ...props
}: {
  contact?: Contact;
  icon?: boolean;
  image?: boolean;
}) {
  if (contact && !contact.isClayUser) {
    return null;
  }

  let IconComponent = ClayUserWithTextIcon;

  if (icon) {
    IconComponent = ClayUserIcon;

    if (image) {
      return <Badge src="/img/contact/icons/clay.png" icon={icon} {...props} />;
    }
  }

  return <IconComponent {...props} />;
}
